export default __webpack_public_path__ + "static/media/Slide20.7a7ff09f.JPG";